/** @typedef {import('@utahdts/utah-design-system').ComponentColors} ComponentColors */
/** @enum {ComponentColors} */
export const componentColors = {
  PRIMARY: /** @type {ComponentColors} */ ('primary'),
  SECONDARY: /** @type {ComponentColors} */ ('secondary'),
  ACCENT: /** @type {ComponentColors} */ ('accent'),
  NONE: /** @type {ComponentColors} */ ('none'),
};
